import { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Portfolio from '../components/Portfolio';
import About from '../components/About';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import AmbientSound from '../components/AmbientSound';

function Home() {
    const [isSoundMuted, setIsSoundMuted] = useState(true);

    const toggleSound = () => {
        setIsSoundMuted(!isSoundMuted);
    };

    return (
        <>
            <Header onSoundToggle={toggleSound} isSoundMuted={isSoundMuted} />
            <AmbientSound isMuted={isSoundMuted} />
            <main>
                <Hero />
                <Services />
                <Portfolio />
                <About />
                <Contact />
            </main>
            <Footer />
        </>
    );
}

export default Home;
